import React, { useEffect, useState } from 'react';
import { IConfig } from '../../../Interfaces/IConfig';
import { ILegalTransactionFullObject } from '../../../Interfaces/ILegalTransaction';
import { IInvoiceFullObject } from '../../../Interfaces/IInvoice';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  TableCell,
  TableRow,
  useTheme,
} from '@mui/material';
import QRCode from 'qrcode';
import { DocumentRequest } from '../Document/DocumentRequest';
import { InvoiceStateChip } from './InvoiceStateChip';

interface IProps {
  configObject: IConfig;
  invoice: IInvoiceFullObject;
  legalTransactionObject: ILegalTransactionFullObject;
  handleClose?: () => void;
}

export const InvoiceDesktopRow: React.FC<IProps> = ({
  configObject,
  invoice,
  legalTransactionObject,
  handleClose,
}) => {
  const theme = useTheme();

  const [qrDataSring, setQrDataSring] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (invoice.EPCString !== null) {
      QRCode.toDataURL(invoice.EPCString)
        .then(url => {
          console.log(url);
          setQrDataSring(url);
        })
        .catch(err => {
          console.error(err);
        });
    }
  }, []);

  return (
    <>
      {isOpen && qrDataSring !== null && (
        <Dialog open onClose={() => setIsOpen(false)}>
          <DialogContent>
            <img
              src={qrDataSring}
              alt='Preview'
              style={{ height: 250, cursor: 'pointer' }}
            />
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={() => setIsOpen(false)}>
              Schließen
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <TableRow>
        <TableCell>{invoice.idDocument}</TableCell>

        <TableCell>
          {qrDataSring === null ? (
            <>-</>
          ) : (
            <img
              src={qrDataSring}
              alt='Preview'
              style={{ height: 30, cursor: 'pointer' }}
              onClick={() => setIsOpen(true)}
            />
          )}
        </TableCell>

        <TableCell>
          <InvoiceStateChip invoice={invoice} />
        </TableCell>
        <TableCell>
          {invoice.Total === null
            ? '-'
            : invoice.Total.toLocaleString('de-DE') + ' €'}
        </TableCell>
        <TableCell>{invoice.FileName}</TableCell>
        <TableCell>
          <DocumentRequest
            key={`request-invoice-${invoice.idInvoice}`}
            documentObject={invoice}
            legalTransaction={legalTransactionObject}
          />
        </TableCell>
      </TableRow>
    </>
  );
};
